import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const BellNotificationIcon = ({
  width = 24,
  height = 24,
  stroke = '#52575C',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 10.2C15.5 8.82087 14.9732 7.49823 14.0355 6.52304C13.0979 5.54786 11.8261 5 10.5 5C9.17392 5 7.90215 5.54786 6.96447 6.52304C6.02678 7.49823 5.5 8.82087 5.5 10.2C5.5 16.2667 3 18 3 18H18C18 18 15.5 16.2667 15.5 10.2Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 21C11.8476 21.3042 11.6288 21.5566 11.3655 21.7321C11.1023 21.9076 10.8038 22 10.5 22C10.1962 22 9.89774 21.9076 9.63449 21.7321C9.37123 21.5566 9.15244 21.3042 9 21"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
